import { useState } from 'react';
import type { IAccordion } from '../../types/accordion';
import {
  ChevronDown,
  ChevronUp
} from './../../assets/Icons';
import styles from './accordion.module.scss';

export const Accordion = ({
  type = 'bordered_box',
  children,
  header,
  hasDivider,
  isOpen,
  alignment = 'start',
  onAccordionToggle,
}: IAccordion) => {
  
  const [isOpened, setIsOpened] = useState(isOpen);

  const handleToggle = (open: boolean) => {
    setIsOpened(open);
    onAccordionToggle?.(open);
  }

  return (
    <details
      open={isOpen}
      data-accordion-type={type}
      data-accordion-with-divider={hasDivider}
      data-accordion-header-alignment={alignment}
      className={styles['accordion']}
    >
      <summary onClick={() => handleToggle(!isOpened)}>
        {header}
        <div className={styles['accordion__chevron-holder']}>
          {isOpened ? ChevronUp : ChevronDown}
        </div>
      </summary>
      {<div className={styles['accordion__body']}>{children}</div>}
    </details>
  );
};
